// Flag local que sobrevive a kill do app — mesmo padrão de
// src/features/onboarding/onboardingFlag.ts (copiado o ESTILO, não o
// conteúdo: leia aquele arquivo primeiro se for mexer aqui).
//
// Por que isto precisa sobreviver a kill: a tela de Sessão (Etapa 12, spec
// S03) reduz o brilho da tela depois de ~30s sem toque, e PRECISA restaurar
// o brilho original ao sair — inclusive se o app for morto com o brilho
// ainda reduzido (ex.: usuária fecha o app pelo app-switcher em vez de
// voltar pela navegação). Sem persistir o valor ORIGINAL antes de reduzir,
// não haveria como saber, no próximo boot, se existe um brilho "sujo"
// pendente de restauração nem qual era o valor correto para voltar.
//
// Fluxo: `markBrightnessDirty(original)` é chamado assim que a tela reduz o
// brilho PELA PRIMEIRA VEZ nesta visita à tela (guarda o valor de ANTES de
// reduzir — nunca o valor já reduzido, senão uma segunda redução
// "recapturaria" o brilho errado como se fosse o original). A chave só é
// removida (`clearBrightnessDirty`) depois que a restauração de fato rodou
// com sucesso — se o app morrer entre a redução e a restauração, a chave
// continua lá e o próximo boot (app/_layout.tsx) ou a próxima montagem da
// tela de Sessão encontra o valor pendente e restaura.
import AsyncStorage from '@react-native-async-storage/async-storage';

const KEY = 'crochet:session-brightness-dirty';

/** Chamado pela tela de Sessão ao reduzir o brilho pela primeira vez nesta
 * visita — grava o brilho ORIGINAL (de antes da redução), não o reduzido. */
export async function markBrightnessDirty(originalBrightness: number): Promise<void> {
  await AsyncStorage.setItem(KEY, String(originalBrightness));
}

/** `null` quando não há brilho "sujo" pendente de restauração. Caso
 * contrário, o valor original a restaurar (0–1). */
export async function getDirtyBrightness(): Promise<number | null> {
  const value = await AsyncStorage.getItem(KEY);
  if (value === null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/** Chamado só depois que a restauração de brilho já rodou com sucesso. */
export async function clearBrightnessDirty(): Promise<void> {
  await AsyncStorage.removeItem(KEY);
}
